
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/buy/[productId]",
      function () {
        return require("private-next-pages/buy/[productId]/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/buy/[productId]"])
      });
    }
  